"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgLink = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_LINK", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m13.121 7.122-.057.057c.278.781.413 1.603.405 2.423l1.067-1.066a5 5 0 0 0-7.072-7.071L5.996 2.933a5 5 0 0 0 2.808 8.483 3.02 3.02 0 0 1-.213.236l-1.466 1.466a3 3 0 1 1-4.243-4.243l.055-.054a7.018 7.018 0 0 1-.405-2.424L1.468 7.461a5 5 0 1 0 7.071 7.07l1.466-1.465a4.978 4.978 0 0 0 1.183-1.879 5.01 5.01 0 0 0-1.183-5.192 4.978 4.978 0 0 0-2.808-1.411c.066-.082.137-.16.213-.237L8.88 2.88a3 3 0 1 1 4.242 4.243Zm-6.589-.59a2.99 2.99 0 0 1 2.059.877c.57.57.862 1.312.878 2.059A2.99 2.99 0 0 1 7.41 8.59a2.99 2.99 0 0 1-.878-2.059Z" }))); };
exports.default = SvgLink;
